import { Stack } from '../../../../shared/ui/Stack/Stack';
import { Text } from '../../../../shared/ui/Text/Text';
import styles from './AboutMe.module.scss';
import myPhoto from '../../../../shared/assets/photo/lena.jpg';
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';
import { sliderData } from '../../lib/data';
import Slider from '../Slider/Slider';
import { Link } from 'react-router-dom';
import { getRouteMyWorks } from '../../../../app/providers/router/config/helpers';
import {motion as m} from "framer-motion";


const AboutMe = () => {
    return ( 
        <section className = {styles.container}>
            <m.div
                initial = 'hidden'
                animate = 'visible'
                variants={{
                    hidden: {
                        opacity: 0,
                    },
                    visible: {
                        opacity: 1,
                        transition: {
                            duration: 2,
                        }
                    }
                }}
            >
            <Stack 
                justifyContent = 'justifyCenter'   
                className={styles.title__content}>
                    <m.div
                        variants = {{
                        hidden:{ opacity: 0, y:20},
                        visible: { opacity: 1, y: 0}
                    }}
                    transition = {{ duration: 0.6 }}>
                    <Text                   
                        type="h3" 
                        size='l' 
                        className={styles.title}>
                        обо мне
                    </Text>   
                    </m.div> 
            </Stack>
            </m.div>
            <div  className={styles.content}> 
                <m.div
                initial= {{opacity:0, x:-40}}
                animate= {{opacity:1, x:0}}
                transition = {{ duration: 5 }}>                  
                <img className={styles.image} src={myPhoto} alt='Елена Ковешникова'/>
                </m.div>
               <Text size='l' className={styles.text__accent}>Я, Елена Ковешникова, детский и семейный фотограф.</Text>
                <Text size='m' className={styles.text}> В каждую проведенную фотосессию я вкладываю частичку себя, 
                        свою душу. Я умею видеть не только правильные ракурсы и красивый свет,
                        но что главнее, я умею видеть мир вашими глазами.
                        Со мной вы получите качественные фотографии с искренними эмоциями,
                        а сама фотосессия пройдет в непринужденной атмосфере. 
                        Помогу вам сохранить неповторимые моменты вашей жизни, 
                        чтобы они наполняли вас положительными эмоциями  
                        каждый раз, когда вы будете пересматривать эти фото.
                </Text>
            </div>

            <div>
            <Swiper
                slidesPerView={4}
                spaceBetween={10}
                freeMode={true}            
                modules={[FreeMode, Autoplay]}            
                loop={true}            
                autoplay={{
                    delay: 3000, 
                    disableOnInteraction: false, 
                }}
                speed={3000} 
                breakpoints={{
                    1440: {
                      slidesPerView: 4,
                    },
                    590: {
                        slidesPerView: 3,
                      },
                      340: {
                        slidesPerView: 2,
                      },
                      140: {
                        slidesPerView: 1,
                      },
                  }}
                className={styles.slider}>

                {sliderData.map((element) => 
                    <SwiperSlide className = {styles.slide} key={element.id}>
                        <Slider
                            element={element}
                        >
                        </Slider>                         
                    </SwiperSlide>
                )}            
            </Swiper> 
            </div>
            <Stack
                justifyContent = 'justifyCenter'   
                className={styles.title__content}
                >
                
                <Link to={getRouteMyWorks()} className={styles.portfolio}>
                        Портфолио
                </Link>
            </Stack>
        </section>
     );
}
 
export default AboutMe;